import { isEqual, isNil, keyBy, keys, sortBy, transform } from 'lodash';
const getMapDifferences = (prevGraphElements, newGraphElements) => {
    const prevMap = keyBy(prevGraphElements, 'id');
    const currentMap = keyBy(newGraphElements, 'id');
    const prevIds = sortBy(keys(prevMap));
    const currentIds = sortBy(keys(currentMap));
    const added = [];
    const removed = [];
    const updated = [];
    let i = 0;
    let j = 0;
    while (i < prevIds.length && j < currentIds.length) {
        const prevId = prevIds[i];
        const currId = currentIds[j];
        if (prevId === undefined || currId === undefined) {
            continue;
        }
        if (prevId === currId) {
            if (!isEqual(prevMap[prevId], currentMap[currId])) {
                updated.push(currId);
            }
            i += 1;
            j += 1;
        }
        else if (prevId < currId) {
            removed.push(prevId);
            i += 1;
        }
        else {
            added.push(currId);
            j += 1;
        }
    }
    while (i < prevIds.length) {
        const prevId = prevIds[i];
        if (prevId === undefined) {
            continue;
        }
        removed.push(prevId);
        i += 1;
    }
    while (j < currentIds.length) {
        const currId = currentIds[j];
        if (currId === undefined) {
            continue;
        }
        added.push(currId);
        j += 1;
    }
    return {
        added: added.map((id) => currentMap[id]).filter((n) => !isNil(n)),
        removed: removed.map((id) => prevMap[id]).filter((n) => !isNil(n)),
        updated: updated.map((id) => currentMap[id]).filter((n) => !isNil(n))
    };
};
const getNodeAttributeDifferences = (prevNodes, newNodes) => {
    const prevNodeMap = keyBy(prevNodes, 'id');
    return newNodes
        .map((nodeToUpdate) => {
        const previousNode = prevNodeMap[nodeToUpdate.id];
        if (previousNode === undefined) {
            return null;
        }
        return transform(nodeToUpdate, (result, value, key) => {
            if (key === 'id' || value !== previousNode[key]) {
                Object.assign(result, { [key]: value });
            }
        });
    })
        .filter((n) => n !== null && Object.keys(n).length > 1);
};
export { getNodeAttributeDifferences, getMapDifferences };
